// src/TitlePage.tsx
import { useEffect } from 'react'
import { Box } from '@mui/material' // Импортируем компонент кнопки звука
import ContentTitle from '../components/Title/ContentTitle' // Импортируем компонент контента // Импортируем новый компонент заголовка // Иконка стрелки вниз

export default function TitlePage() {
  //   const [muted, setMuted] = useState(true)

  useEffect(() => {
    document.title = 'Turtton - Главная'
  }, [])

  return (
    <div className='relative h-[350px] lg:h-screen w-full'>
      <Box
        component="div"
        sx={{
          position: 'absolute',
          top: '-4%',
          left: 0,
          width: '100%',
          height: '108%',
          zIndex: -1,
          overflow: 'hidden',
        }}
      >
        <img
          src="/title/header.webp" // ← путь к твоему фото
          alt="Фоновое изображение"
          className="w-full h-full object-cover"
        />
      </Box>
      {/* Затемняющий overlay */}
      {/* <div className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.5)] z-[1]"></div> */}
      {/* Контент поверх видео */}
      <ContentTitle />
    </div>
  )
}
